import React from 'react'
import Store from '@Store'

export const wrapRootElement = ({ element }) => (<Store>{element}</Store>)

export const onRouteUpdate = () => {
    var event = new CustomEvent("startLoading", {detail: {}});
    window.dispatchEvent(event);
}